// Preserve schema order and meaningful falsy values such as 0 and false.
export function getMapLabel(fields = [], values = {}) {
  return [...fields]
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .filter(field => field.visible_on_map)
    .map(field => values[field.key])
    .filter(
      value =>
        value !== null && value !== undefined && String(value).trim() !== ''
    )
    .map(value =>
      typeof value === 'boolean' ? (value ? 'Yes' : 'No') : String(value).trim()
    )
    .join('\n');
}

// Icons use a top-left anchor. Place upright text above their rotated bounds.
export function getMapLabelOffset(width, height, scale, rotation) {
  const cos = Math.cos(rotation);
  const sin = Math.sin(rotation);
  const xs = [0, width * cos, -height * sin, width * cos - height * sin];
  const ys = [0, width * sin, height * cos, width * sin + height * cos];
  return {
    offsetX: ((Math.min(...xs) + Math.max(...xs)) * scale) / 2,
    offsetY: Math.min(...ys) * scale - 10,
  };
}
